// src/features/mech/plastics/playbook/PlasticsPlayBook.jsx
// Plastics Molding-specific PlayBook configuration component

import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import PerlSlider from "../../../../shared/components/PerlSlider";
import { theme } from "../../../../design/theme";

const { perlColors } = theme.custom;

/**
 * CorrugatedPlayBook - Corrugated Box-specific playbook configuration
 * 
 * @param {Object} props
 * @param {Object} props.data - PlayBook data object with costParams: { corrugationRate, ohpRate, blankLengthCm, blankWidthCm, areaNetM2, wastagePercent }
 * @param {Function} props.onChange - Callback: (field, value) => void
 */
export default function GlassbottlesPlayBook({ data = {}, onChange }) {
  // Extract costParams from data.costParams or data directly (for backward compatibility)
  const costParams = data.costParams || {
    corrugationRate: data.corrugationRate || 0,
    cycleTime: data.cycleTime || 0,
    machineTonnage: data.machineTonnage || 0,
    ohpRate: data.ohpRate || 0,
    blankLengthCm: data.blankLengthCm || 0,
    blankWidthCm: data.blankWidthCm || 0,
    areaNetM2: data.areaNetM2 || 0,
    wastagePercent: data.wastagePercent || 0,
  };

  // Handler for parameter changes - updates costParams structure
  const handleParameterChange = (paramName, value) => {
    if (onChange) {
      // Update the costParams nested structure
      onChange("costParams", {
        ...costParams,
        [paramName]: value,
      });
    }
  };


  return (
    <Box>
      {/* Process Parameters Title */}
      <Typography
        variant="subtitle2"
        fontWeight={600}
        sx={{ mb: 2, color: perlColors.textPrimary }}
      >
        Process Parameters
      </Typography>

      {/* Sliders (Cycle Time and OHP Rate) */}
      <Box
        sx={{
          backgroundColor: perlColors.surface,
          borderRadius: 2,
          p: 3,
          display: "flex",
          flexDirection: "column",
          gap: 3,
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
          <Box
            sx={{
              minWidth: 220,
              flex: "1 1 280px",
              maxWidth: "calc((100% - 24px) / 2)",
              mb: 2,
            }}
          >
            <PerlSlider
              label="Cycle Time"
              value={costParams.cycleTime ? parseFloat(parseFloat(costParams.cycleTime).toFixed(2)) : 0}
              min={0}
              max={300}
              step={0.1}
              unit="sec"
              onChange={(e, v) => handleParameterChange("cycleTime", parseFloat(v.toFixed(2)))}
            />
          </Box>
          <Box
            sx={{
              minWidth: 220,
              flex: "1 1 280px",
              maxWidth: "calc((100% - 24px) / 2)",
              mb: 2,
            }}
          >
            <PerlSlider
              label="OHP Rate"
              value={costParams.ohpRate ? parseFloat(parseFloat(costParams.ohpRate).toFixed(2)) : 0}
              min={0}
              max={30}
              step={0.5}
              unit="%"
              onChange={(e, v) => handleParameterChange("ohpRate", parseFloat(v.toFixed(2)))}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
